import {
  Button,
  ButtonGroup,
  Stack,
  Icon,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { FEATURES } from '@habity/constants';
import { ICONS } from '~/constants/icons';
import { useAppStore } from '~/store/useAppStore';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { getFilterArrayValues } from '@habity/services';
import { FeatureType } from '@habity/types';
import { useAgency } from '~/hooks/useAgency';
import { getFeatureButtonIcon } from '~/constants';

export const Features = ({
  ignoreSearch = false,
}: {
  ignoreSearch?: boolean;
}) => {
  const filters = useHomesStore((state) => state.filters);
  const isMobile = useAppStore((state) => state.isMobile);
  const { performSearch } = useFilters();
  const { is_rental_unit, features, categories } = filters || {};
  const { agency } = useAgency();
  const { settings } = agency || {};
  const { showRentalUnitButton } = settings?.search || {};

  const onToggle = (values: FeatureType) => {
    const newFeatures = getFilterArrayValues(values, features);
    performSearch({ filters: { features: newFeatures }, ignoreSearch });
  };

  return (
    <Stack spacing="2">
      <ButtonGroup>
        <Wrap>
          {FEATURES
            .filter(
              (f) =>
                !f.hidden &&
                !categories?.some((c) => f?.hide_for_categories?.includes(c))
            )
            .toSorted((a, b) => a.title.localeCompare(b.title))
            .map((b) => (
              <WrapItem key={b.title}>
                <Button
                  w="full"
                  size="sm"
                  variant="outline"
                  borderColor="blackAlpha.400"
                  onClick={() => onToggle(b.key)}
                  leftIcon={<Icon as={getFeatureButtonIcon(b.key)} />}
                  isActive={features?.includes(b.key)}
                  _active={{
                    backgroundColor: 'blackAlpha.50',
                    borderColor: "black",
                    borderWidth: "2px",
                  }}
                >
                  {b.title}
                </Button>
              </WrapItem>
            ))}

          {showRentalUnitButton && (
            <WrapItem>
              <Button
                w="full"
                size="sm"
                variant="outline"
                borderColor="blackAlpha.400"
                onClick={() =>
                  performSearch({
                    filters: {
                      is_rental_unit: is_rental_unit ? undefined : true,
                    },
                  })
                }
                leftIcon={<Icon as={ICONS.RENTAL_UNIT} />}
                isActive={is_rental_unit || false}
                _active={{
                  backgroundColor: 'blackAlpha.50',
                  borderColor: "black",
                  borderWidth: "2px",
                }}
              >
                Hyresrätt
              </Button>
            </WrapItem>
          )}
        </Wrap>
      </ButtonGroup>
    </Stack>
  );
};
